import { yupResolver } from '@hookform/resolvers/yup';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { LoadingButton } from '@mui/lab';
import { IconButton, InputAdornment, Stack } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import * as Yup from 'yup';

const ChangePasswordForm = ({ onSent, onGetPassword, token }) => {
  const { t: translate } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const changePasswordSchema = Yup.object().shape({
    password: Yup.string().required(translate('custom_email.password_is_required')),
  });
  const methods = useForm({
    resolver: yupResolver(changePasswordSchema),
    defaultValues: { password: '' },
  });
  const changePasswordSuccessCallback = (data, message) => {
    onSent();
    onGetPassword(data.password);
  };
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;
  const onSubmit = (data) => {
    let changePasswordForm = {
      token: token,
      password: data.password,
    };
    let postProps = {
      url: userModuleURL.changePasswordRequest,
      body: changePasswordForm,
      successCallback: changePasswordSuccessCallback,
    };
    HttpServices.Post(postProps);
  };
  return (
    <>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={3}>
          <RHFTextField
            name="password"
            type={showPassword ? 'text' : 'password'}
            label={translate('profile.change_password.title')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
            {translate('profile.change_password.title')}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </>
  );
};
export default ChangePasswordForm;
